
import { createSlice } from "@reduxjs/toolkit";
import { GetAllClaimPayment } from "./PaymentApi";


const defaultFilters = {
    branch_id: '',
    payer: '',
    insurance: '',
    payment_number: '',
    claim_number: '',
    status: '',
    by_batch: true,
    by_received_date: false,
    start_date: '',
    end_date: ''
}

const PaymentSlice = createSlice({
    name: "Payment",
    initialState: {
        paymentFilters: defaultFilters,
        allPaymentList: [],
    },
    reducers: {
        handlePaymentFilter: (state, action) => {
            state.paymentFilters[action?.payload?.check] = action?.payload?.value;
        },
        handleResetFilter: (state, _) => {
            state.paymentFilters = defaultFilters
        }
    },
    extraReducers: (builder) => {
        builder.addCase(GetAllClaimPayment.fulfilled, (state, action) => {
            state.allPaymentList = action?.payload?.data
        })
    }
})

export const { handlePaymentFilter, handleResetFilter } = PaymentSlice.actions
export default PaymentSlice.reducer